export function identity(value) {
    return value;
}

export function isDefined(value) {
    return typeof value !== "undefined";
}


// WEBPACK FOOTER //
// ./src/core/utils.ts